import React from 'react'
import Analytics from '../../services/analytics'
import { clickHandler } from '../../util/clickHandler'
/**
 * Icon component for the first page navigation.
 *
 * @returns {JSX.Element} The icon element with analytics event.
 */
export const BackButton = () => {
  const onClick = () => {
    Analytics.push({
      dataLayer: {
        event: 'pagination_by',
        pagination_by_direction: 'previous',
      },
    })
  }

  return (
    <span
      className='material-symbols-outlined'
      style={{ fontSize: '16px' }}
      {...clickHandler(onClick)}
    >
      keyboard_backspace
    </span>
  )
}

/**
 * Icon component for the last page navigation.
 *
 * @returns {JSX.Element} The icon element with analytics event.
 */
export const ForwardButton = () => {
  const onClick = () => {
    Analytics.push({
      dataLayer: {
        event: 'pagination_by',
        pagination_by_direction: 'forward',
      },
    })
  }

  return (
    <span
      className='material-symbols-outlined'
      style={{ fontSize: '16px' }}
      {...clickHandler(onClick)}
    >
      arrow_right_alt
    </span>
  )
}
